import { type FC } from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import { Filter } from "@/partner/shared/components/Filter";

interface PlatformMenuFilterProps {
  onCreateItem: () => void;
}

export const PlatformMenuFilter: FC<PlatformMenuFilterProps> = ({
  onCreateItem,
}) => {
  const { t } = useTranslation();

  return (
    <Filter
      title={t("platformMenu.filter.title")}
      action={
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          disableElevation
          onClick={() => onCreateItem()}
        >
          {t("common.actions.add")}
        </Button>
      }
      fields={{
        search: true,
      }}
    />
  );
};
